import React from 'react';
import PrivilegeNames from '../../constants/privilegeNames';
import { Link } from 'react-router-dom';
import { useReactiveVar } from '@apollo/client';
import { userLicensedOrgUnitId, userPrivileges } from '../../apollo/cache';
import {
  getLegalDocumentsUrl,
  getOrgSearchForUserManagement,
  getUnitSearchForCheckPoints,
  getUnitSearchForReportManagement
} from '../shared/services/getUnitSearchPageUrlService';
import { useClientSessionOmitter } from '@shared/hooks/useClientSessionOmitter';
import NotificationCenter from '../notifications/notificationCenter/NotificationCenter';

const HeaderLinks = () => {
  const privileges = useReactiveVar(userPrivileges);
  const orgUnitId = useReactiveVar(userLicensedOrgUnitId);
  const { endCMMISession } = useClientSessionOmitter();

  return (
    <>
      {privileges && privileges.includes(PrivilegeNames.Calendar) && (
        <Link to='/calendar'>Calendar</Link>
      )}
      {privileges && privileges.includes(PrivilegeNames.ReportManagement) && (
        <Link to={getUnitSearchForReportManagement(privileges, orgUnitId)}>Report Management</Link>
      )}
      {privileges && privileges.includes(PrivilegeNames.UserManagement) && (
        <Link to={getOrgSearchForUserManagement(privileges)}>User Management</Link>
      )}
      {privileges && privileges.includes(PrivilegeNames.CheckPoints) && (
        <Link to={getUnitSearchForCheckPoints(privileges, orgUnitId)}>Check Points</Link>
      )}

      {privileges && privileges.includes(PrivilegeNames.Invoices) && (
        <Link to='/invoices'>Invoices</Link>
      )}

      {privileges && privileges.includes(PrivilegeNames.LegalDocuments) && (
        <Link to={getLegalDocumentsUrl(privileges)}>Legal Documents</Link>
      )}

      {privileges &&
        (privileges.includes(PrivilegeNames.EmailPreferences) ||
          privileges.includes(PrivilegeNames.AppraiserProfile)) && (
          <Link to='/account'>Account</Link>
        )}

      {privileges?.includes(PrivilegeNames.NotificationCenter) && <NotificationCenter />}

      <a onClick={endCMMISession}>Log Out</a>
    </>
  );
};

export default HeaderLinks;
